import React, { useState } from 'react';
import Typography from 'kingpin/atoms/Typography';
import styled from 'styled-components';
import Row from '../../components/Common/Row';
import ErrorBanner, { AUTH_ERROR_MSG_KEY } from './ErrorBanner';
import Legal from './Legal';
import EmailPasswordLoginForm from './EmailPasswordLoginForm';
import MicrosoftLoginButton from './MicrosoftLoginButton';
import AuthLinks from './AuthLinks';
import { ReactComponent as Logo } from '../../images/brand-dark.svg';
import MicrosoftTenantRequired from './MicrosoftTenantRequired';
import useTenantQueryParam from './useTenantQueryParam';
import OrDivider from './OrDivider';

const Page = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: var(--color-bg-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
`;

const Column = styled.div`
  width: 400px;
  height: 100vh;
  padding: 40px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const LoginContainer = styled.div`
  border: var(--color-grey-8) 1px solid;
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: var(--shadow-sm);
`;

const LoginFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const LoginLogo = styled(Logo)`
  width: 132px;
  height: auto;
`;

const LoginScreen = () => {
  const tenant = useTenantQueryParam();
  const [isTenantRequired, setIsTenantRequired] = useState<
    | {
        isRequired: boolean;
        email: string;
      }
    | undefined
  >(undefined);

  if (isTenantRequired) {
    return (
      <MicrosoftTenantRequired
        email={isTenantRequired.email}
        setIsTenantRequired={setIsTenantRequired}
      />
    );
  }

  return (
    <Page>
      <ErrorBanner errorKey={AUTH_ERROR_MSG_KEY} />
      <Column>
        <Row style={{ justifyContent: 'center' }}>
          <LoginLogo />
        </Row>
        <LoginContainer>
          <LoginFormContainer>
            <Row style={{ justifyContent: 'center' }}>
              <Typography.Header type="H1">Log In</Typography.Header>
            </Row>
            {!tenant && (
              <>
                <EmailPasswordLoginForm />
                <OrDivider />
              </>
            )}
            <MicrosoftLoginButton
              setIsTenantRequired={setIsTenantRequired}
              tenant={tenant}
            />
            {!tenant && <AuthLinks />}
          </LoginFormContainer>
        </LoginContainer>
        <Legal />
      </Column>
    </Page>
  );
};

export default LoginScreen;
